module.exports = __webpack_public_path__ + "img/744.0162fa2d.jpg";